import { useCallback, useRef } from 'react'
import { useSafeState } from './use-safe-state'

const defaultDebounceFunction = cb => {
    const timer = setTimeout(() => cb(), 200)
    return () => {
        clearTimeout(timer)
    }
}

export function useDebouncedForcedRender(debounceFunction) {
    const debounce = typeof debounceFunction === 'function' ? debounceFunction : defaultDebounceFunction
    const forceRender = useForcedRender()
    const cleanup = useRef()

    const forceRenderDebounced = useCallback(() => {
        typeof cleanup.current === 'function' && cleanup.current()
        cleanup.current = debounce(forceRender)
    }, [forceRender, debounce, cleanup])

    return {
        cancelRender: useCallback(() => {
            if (typeof cleanup.current === 'function') {
                cleanup.current()
                cleanup.current = null
            }
        }, [cleanup]),
        forceRender: forceRenderDebounced
    }
}

export function useForcedRender() {
    // eslint-disable-next-line no-unused-vars
    const [count, setCount] = useSafeState(0)

    const forceRender = useCallback(() => setCount(count => count + 1), [setCount])

    return forceRender
}
